export const trmShopMode = {
	pathesToCheck: ["shopMode"],
	tr: {
		shopMode: {
			Catalog: {
				Headline: {
					DE: "Wichtiger Hinweis",
					EN: "Important note",
					FR: "Note importante",
				},
				Explanation: {
					DE: "Wir führen momentan Wartungsarbeiten durch. Sie können weiterhin alle Produkte ansehen und in unserem Sortiment stöbern, vorübergehend aber nichts in den Warenkorb legen, bestellen oder Ihre Kundendaten ändern.",
					EN: "We are currently carrying out maintenance work. You can still view all products and browse our assortment, but for the time being you cannot add anything to the shopping cart, place orders or change your customer data.",
					FR: "Nous effectuons actuellement des travaux de maintenance. Vous pouvez toujours consulter tous les produits et parcourir notre assortiment, mais vous ne pouvez temporairement rien ajouter au panier, passer commande ou modifier vos données client.",
				},
				Apology: {
					DE: "Wir entschuldigen uns für die Unannehmlichkeiten und sind so schnell wie möglich wieder vollständig für Sie da.",
					EN: "We apologise for the inconvenience and will be fully back for you as soon as possible.",
					FR: "Nous nous excusons pour la gêne occasionnée et serons de nouveau pleinement à votre disposition dès que possible.",
				},
				Hint: {
					DE: "Wegen Wartungsarbeiten momentan nicht möglich.",
					EN: "Not possible at the moment due to maintenance work.",
					FR: "Impossible pour le moment en raison de travaux de maintenance.",
				},
			},
			Maintenance: {
				Headline: {
					DE: "Wartungsmodus",
					EN: "Maintenance Mode",
					FR: "Mode Maintenance",
				},
				Explanation: {
					DE: "Unser Onlineshop wird gerade gewartet. Bald sind wir wieder für Sie da!",
					EN: "Our online shop is currently under maintenance. We will be back for you soon!",
					FR: "Notre boutique en ligne est actuellement en maintenance. Nous serons bientôt de retour pour vous !",
				},
				Contact: {
					DE: "Sie möchten uns erreichen? Schreiben Sie uns einfach an: info[at]electronic-shop.lu",
					EN: "You want to reach us? Just write to us at: info[at]electronic-shop.lu",
					FR: "Vous souhaitez nous joindre ? Écrivez-nous simplement à : info[at]electronic-shop.lu",
				},
			},
		},
	},
};
